import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { OtaApiService } from '../CommonController/ota-api-service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-ota-batch-details',
  templateUrl: './ota-batch-details.component.html',
  styleUrls: ['./ota-batch-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class OtaBatchDetailsComponent implements OnInit {
  pageSize = 10;
  currentPage = 1;
  totalItems = 0;
  headerlist = [];
  deviceOtaList = [];
  batchRefId;
  deviceOTAForm: FormGroup;
  userPermissions;
  userName;
  userType;
  role;

  OtaBatchId;
  OtaBatchName;
  OtaBatchDescription;
  OtaBatchDate;
  totalPending = 0;
  totalUploaded = 0;
  totalInitiated = 0;
  totalInProgress = 0;
  totalAborted = 0;
  totalCompleted = 0;
  status = '';
  searchText = '';

  viewOta = false;
  updateOta = false;

  constructor(
    public otaApiService: OtaApiService,
    public commonApiService: CommonApiService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.status = '';
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userName = sessionStorage.getItem('userName');
    this.userType = sessionStorage.getItem('roleType');
    this.role = sessionStorage.getItem('roleType');
    this.deviceOTAForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
      batchDetailsSearch: new FormControl(''),
    });
    if (this.route.snapshot.paramMap.get('otaRefId')) {
      this.batchRefId = this.route.snapshot.paramMap.get('otaRefId');
      this.fetchBatchListSingle();
    }
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Ota' && element.view === true) {
        this.viewOta = true;
      }
      if (element.pageName === 'Ota' && element.update === true) {
        this.updateOta = true;
      }
    });
  }

  fetchBatchListSingle() {
    this.spinner.show();
    this.otaApiService
      .fetchOtaBatchdetails(
        this.batchRefId,
        this.searchText,
        this.status,
        this.currentPage,
        this.pageSize
      )
      .subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.OtaBatchId = res.data.id;
              this.OtaBatchName = res.data.name;
              this.OtaBatchDescription = res.data.description;
              this.OtaBatchDate = this.datepipe.transform(
                res.data.createAt,
                'dd MMM yyyy hh:mm:ss a'
              );
              this.deviceOtaList = res.data.deviceDetails;
              this.totalItems = res.totalItems;

              if (
                (this.status === '' ||
                  this.status === null ||
                  this.status === undefined) &&
                this.status === ''
              ) {
                this.totalUploaded = res.data.submittedDeviceCount;
                this.totalInitiated = res.data.initiatedDeviceCount;
                this.totalInProgress = res.data.inprogressDeviceCount;
                this.totalAborted = res.data.abortedDeviceCount;
                this.totalCompleted = res.data.completeDeviceCount;
                this.totalPending = res.data.totalPendingDeviceCount;
              }

              this.commonApiService.openSnackbar(res.message);
            }
          } catch (error) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
      });
  }

  abort(deviceId) {
    if (confirm('Are you sure to Abort Device')) {
      this.spinner.show();
      this.otaApiService.abortOtaDevice(deviceId).subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          } catch (error) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
        complete: () => {
          this.ngOnInit();
        },
      });
    }
  }

  navigateBack() {
    this.commonApiService.back();
  }

  scrollTo(status) {
    this.status = status;
    this.currentPage = 1;
    this.deviceOtaList = [];
    this.fetchBatchListSingle();
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchBatchListSingle();
  }

  onSizeChange(newSize): void {
    this.currentPage = 1;
    this.pageSize = newSize;
    this.fetchBatchListSingle();
  }

  onKeyUpEventBatchList(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.deviceOtaList = [];
    this.fetchBatchListSingle();
  }

  onClear(event) {
    console.log('clear', event);
    this.searchText = event;
  }
}
